var App = App || {};

App.WidgetStories = (function ($) {
    'use strict';

    let timer;
    let timerCounter = 0;
    const timerDuration = 10000;
    const timerInterval = 10;

    const controlsStories = $(".widget-stories .widget-stories-list button");
    const controls = $(".widget-stories .widget-stories-controls button");
    const controlsPause = $(".widget-stories .widget-stories-controls [data-stories='pause']");
    const controlsReset = $(".widget-stories .widget-stories-controls [data-stories='reset']");

    function Init() {
        controlsStories.on("click", function () {
            StoriesClear();
            StoryActivate($(this));
            timer = setInterval(StoriesBehavior, timerInterval, $(this));
            controls.show();
        }).on("keydown", function (e) {
            StoryKeydown($(this), e);
        });
        controlsPause.on("click", function () {
            StoriesClear();
            controlsPause.hide();
        });
        controlsReset.on("click", function () {
            StoriesClear();
            StoryActivate(controlsStories.first());
            controls.hide();
        });
    }

    function StoriesBehavior(elem) {
        timerCounter++;
        const progressInt = 60 + timerCounter * (314 / (timerDuration / timerInterval));
        const progressElem = elem.find("circle");

        progressElem.css({ "stroke-dashoffset": progressInt });

        if (progressInt >= 314) {
            StoriesClear();

            var next = elem.parents("li").next("li").find("button");
            if (next.length) {
                StoryActivate(next);
                timer = setInterval(StoriesBehavior, timerInterval, next);
            }
            else {
                StoryActivate(controlsStories.first());
                controls.hide();
            }
        }
    }

    function StoriesClear() {
        clearInterval(timer);
        timerCounter = 0;
        controlsStories.find("circle").removeAttr("style");
    }

    function StoryActivate(elem) {

        const control = elem;
        const controlSiblings = control.parents("li").siblings("li").find("button");

        control.attr("aria-selected", true);
        controlSiblings.attr("aria-selected", false);

        const story = $(`#${elem.attr("aria-controls")}`);
        const storySiblings = story.siblings(".story");

        story.stop().removeClass("fadeOut").fadeIn(350);
        storySiblings.stop().addClass("fadeOut").fadeOut(350, function () {
            $(this).removeClass("fadeOut")
        });
    }

    function StoryKeydown(story, e) {

        const arrowsNext = ["ArrowRight", "ArrowDown"];
        const arrowsPrev = ["ArrowLeft", "ArrowUp"];

        if ([...arrowsNext, ...arrowsPrev].includes(e.key)) {

            let storyWhich;

            if (arrowsNext.includes(e.key)) {
                e.preventDefault();
                storyWhich = story.parents("li").is(":last-child")
                    ? story.parents("ul").children("li:first").find("button")
                    : story.parents("li").next("li").find("button");
            }
            else if (arrowsPrev.includes(e.key)) {
                e.preventDefault();
                storyWhich = story.parents("li").is(":first-child")
                    ? story.parents("ul").children("li:last").find("button")
                    : story.parents("li").prev("li").find("button");
            }

            storyWhich.removeAttr("tabindex").focus();
            storyWhich.parents("li").siblings("li").children("button").attr("tabindex", "-1")
            StoryActivate(storyWhich);
        }
    }

    return {
        Init: Init
    };

})(jQuery);